import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import agent from '../agent';

export const getPendingUpdateDetails = createAsyncThunk(
  "pendingUpdateDetails/getPendingUpdateDetails",
  async (data, thunkApi) => {
    try {
      const response = await agent.requests.get(
        "/subscriptions/pending-update-details",
        data
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const confirmUpdateDetails = createAsyncThunk(
  "pendingUpdateDetails/confirmUpdateDetails",
  async (data, thunkApi) => {
    try {
      const response = await agent.requests.post(
        "/subscriptions/confirm-update-details",
        data
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

const initialState = {
  status: "idle",
  loading: false,
  error: null,
  getPendingUpdateDetailsResponse: {},
  confirmUpdateDetailsResponse: null,
};

const pendingUpdateDetailsSlice = createSlice({
  name: 'pendingUpdateDetails',
  initialState,
  reducers: {
    resetStatus: (state) => {
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder

      // GET
      .addCase(getPendingUpdateDetails.pending, (state) => {
        state.status = "getPendingUpdateDetails/loading";
      })
      .addCase(getPendingUpdateDetails.fulfilled, (state, action) => {
        state.status = "getPendingUpdateDetails/success";
        state.getPendingUpdateDetailsResponse = action.payload;
      })
      .addCase(getPendingUpdateDetails.rejected, (state, action) => {
        state.status = "getPendingUpdateDetails/failed";
        state.error = action.payload;
      })

      // POST CONFIRM
      .addCase(confirmUpdateDetails.pending, (state) => {
        state.status = "confirmUpdateDetails/loading";
      })
      .addCase(confirmUpdateDetails.fulfilled, (state, action) => {
        state.status = "confirmUpdateDetails/success";
        state.confirmUpdateDetailsResponse = action.payload;
      })
      .addCase(confirmUpdateDetails.rejected, (state, action) => {
        state.status = "confirmUpdateDetails/failed";
        state.error = action.payload;
      });
  },
});

export const { resetStatus } = pendingUpdateDetailsSlice.actions;

export const selectPendingUpdateDetailsStatus = (state) =>
  state.pendingupdatedetails?.status;

export const selectPendingUpdateDetails = (state) =>
  state.pendingupdatedetails?.getPendingUpdateDetailsResponse;

export const selectConfirmUpdateDetailsResponse = (state) =>
  state.pendingupdatedetails?.confirmUpdateDetailsResponse;

export const selectPendingUpdateDetailsError = (state) =>
  state.pendingupdatedetails?.error;


export default pendingUpdateDetailsSlice.reducer;
